export const PipelineIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1592_3381)">
        <path
          d="M0.625 13.125H3.125V19.375H0.625V13.125Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.875 8.125H13.125V11.875H6.875V8.125Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.875 0.625H19.375V6.875H16.875V0.625Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.91167 11.875C7.65395 12.6069 7.17519 13.2405 6.5416 13.6884C5.90801 14.1363 5.1509 14.3762 4.375 14.375H3.125V18.125H4.375C6.14657 18.1187 7.85937 17.4889 9.21306 16.3461C10.5668 15.2033 11.4749 13.6204 11.7783 11.875H7.91167Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.624 1.875C13.8525 1.88148 12.1398 2.51132 10.7861 3.6541C9.43248 4.79688 8.52427 6.37967 8.2207 8.125H12.0874C12.3451 7.39315 12.8238 6.75946 13.4574 6.31158C14.091 5.86371 14.8481 5.62379 15.624 5.625H16.874V1.875H15.624Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1592_3381">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
